<script setup lang="ts">
import ApexCharts from 'apexcharts';
import { onBeforeUpdate, onUnmounted, onUpdated, ref } from 'vue';

interface Props {
  title: string;
  options: object;
}

const props = defineProps<Props>();

const chartRef = ref<any>(null);
let chart: any = null;
//
// onUpdated(() => {
//   if (props.options?.xaxis?.categories?.length === 0) return;
//   chart = new ApexCharts(chartRef.value, props.options);
//   chart.render();
// });

onUpdated(() => {
  chart = new ApexCharts(chartRef.value, props.options);
  chart.render();
});

onBeforeUpdate(() => {
  if (chart) {
    chart.destroy();
    chart = null;
  }

  chartRef.value = null;
});

onUnmounted(() => {
  if (chart) chart.destroy();
});
</script>

<template>
  <a-card>
    <template #title>
      {{ props.title }}
    </template>
    <div ref="chartRef" />
  </a-card>
</template>
